<zaeper-dropdown-menu #receiverMenu [menuItems]="(userMenuItems$ | async) ?? []" orientation="right">
  <ng-template zTemplate="trigger">
    <p-button
      [label]="(currentUser$ | async)?.email"
      [text]="true"
      icon="pi pi-chevron-down"
      iconPos="right"
      styleClass="text-surface-950 dark:text-surface-0 whitespace-nowrap"
    >
      <p-avatar [style]="{ 'background-color': (avatarColor$ | async), color: '#ffffff' }" [label]="(initials$ | async) ?? '?'" shape="circle"
                styleClass="mr-2"></p-avatar>
    </p-button>
  </ng-template>
  <ng-template zTemplate="top">
    @if (activeRole$ | async; as role) {
      <div class="max-w-72 border-b border-surface-200 px-4 py-3 dark:border-surface-700">
        @if (activeCompany$ | async; as company) {
          <div class="truncate text-sm font-semibold">{{ company.name }}</div>
        }
        <div class="mt-1 text-sm">
          <span class="text-surface-500 dark:text-surface-400">{{ 'your-role' | zDictionary }}:</span>
          <span class="font-medium">{{ role | zRole }}</span>
        </div>
        <p class="m-0 mt-1 whitespace-normal text-xs text-surface-500 dark:text-surface-400">{{ role | zRole: 'description' }}</p>
      </div>
    }
  </ng-template>
</zaeper-dropdown-menu>
